<template>
  <!-- 참여하기 시작 -->
  <div class="widM txtC marTX">
    <div class="fntH4 fntM padTM padBM" style="color:#fff; background:#3872d3; border-radius:15px 15px 0 0;">
      <strong>참여하기</strong>
    </div>

    <div class="padBX" style="border:1px solid #3872d3; border-top:none; border-radius:0 0 15px 15px;" >
      <span class="disIb" style="border:10px solid transparent; border-top-color:#3872d3;" ></span>
      <p class="fntP marTM"> 3가지 미션을 모두 완료하면 <br class="moOnly" /><em style="color:#3872d3;" ><span style="box-shadow: inset 0 -10px 0 #fdf729;">글리스터 프로액션 컴플리트 치약</span>(여행용 사이즈)</em>를 <br class="moOnly" />선물로 드립니다.
      </p>
      <div class="marTML">
        <img
          src="https://www.amway.co.kr/_ui/_noticeImg/2023/03/0329_ev_a7070xgli/cont_glister_toothpaste.png"
          style="max-width:690px; width:100%;"
          alt="글리스터 프로액션 컴플리트 치약 50 G(여행용 사이즈)"
        />
      </div>
      <p class="colorGray fntP padTM">
        바이옴 특화설계로 지키는 건강한 구강환경 밸런스
      </p>
      <p class="fntH6 padTM" style="color:#3872d3;">
        글리스터 프로액션 컴플리트 <br class="moOnly" />치약 50 G(여행용 사이즈)
        증정
      </p>

      <div class="marTML txtL widXS">
        <form>
          <div class="row cont_info">
            <label class="col-xs-4 control-label" for="a7070xgli_aboname">
              <span class="regular" style="color:#56565a;">이름</span>
            </label>
            <div class="col-xs-8 col last-col">
              <input
                type="text"
                v-model="aboname"
                id="a7070xgli_aboname"
                name="a7070xgli_aboname"
                class="form-control"
                placeholder="이름을 입력하여 주세요."
                style="width:100%"
                maxlength="20"
              />
            </div>
          </div>
          <div class="row padTS cont_info">
            <label class="col-xs-4 control-label" for="a7070xgli_abophone1">
              <span class="regular" style="color:#56565a;">핸드폰 번호</span>
            </label>
            <div
              class="col-xs-8 col last-col"
              style="display: flex; align-items: center; justify-content: space-between;"
            >
              <input
                type="text"
                v-model="phone1"
                id="a7070xgli_abophone1"
                name="a7070xgli_abophone"
                class="form-control"
                placeholder="010"
                style="width:30%;"
                maxlength="3"
                @input="phoneValid()"
              />
              -
              <input
                type="text"
                v-model="phone2"
                id="a7070xgli_abophone2"
                name="a7070xgli_abophone"
                class="form-control"
                placeholder="0000"
                style="width:30%;"
                maxlength="4"
                @input="phoneValid()"
              />
              -
              <input
                type="text"
                v-model="phone3"
                id="a7070xgli_abophone3"
                name="a7070xgli_abophone"
                class="form-control"
                placeholder="0000"
                style="width:30%;"
                maxlength="4"
                @input="phoneValid()"
              />
            </div>
          </div>
          <div class="row padTS cont_info">
            <label class="col-xs-4 control-label" for="a7070xgli_abonumber">
              <span class="regular" style="color:#56565a;" >ABO 번호<br />(또는 소비자 번호)</span>
            </label>
            <div class="col-xs-8 col last-col">
              <input
                type="text"
                v-model="abonumber"
                id="a7070xgli_abonumber"
                name="a7070xgli_abonumber"
                class="form-control"
                placeholder="ABO 번호 또는 소비자 번호"
                style="width:100%"
                maxlength="20"
              />
            </div>
          </div>
          <div class="row padTM">
            <div class="col-xs-12">
              <input id="a7070xgli_agree" type="checkbox" v-model="agree"/>
              <label
                for="a7070xgli_agree"
                class="normal inline-label checklabel"
                style="margin:0;"
                >개인정보 수집, 이용 및 상기 이벤트 내용에 모두 동의합니다.</label>
            </div>
          </div>

          <!-- 버튼 영역 -->
          <div class="row padTX">
            <div class="col-xs-12">
              <!-- 팝업 button onclick class 변경-->
              <div class="osResBtnGrp">
                <button
                  type="button"
                  @click="letGoJoin"
                  class="osResBtn01"
                  style="cursor:pointer;background-color:#00b432;border-radius:2em; width:13em;"
                  v-bind:style="joinButtonColor"
                >
                  선착순 이벤트 신청하기
                </button>
              </div>
              <!-- //팝업 button onclick class 변경 -->
            </div>
          </div>
          <!-- //버튼 영역 -->
        </form>
      </div>
    </div>
  </div>
  <!-- //참여하기 끝 -->
</template>

<script>
export default {
  name: "a7070-glister-join",
  data() {
    return {
      abonumber: '', // ABO 번호 
      aboname: '', // ABO 이름 
      phone1: '', // 휴대폰번호 앞자리 
      phone2: '', // 휴대폰번호 중간자리
      phone3: '', // 휴대폰번호 끝자리
      isPhoneValid: false, // 휴대폰 숫자여부 체크 
      isPhoneValidEmpty: false, // 휴대폰 미입력 체크 
      agree: false, // 개인정보동의 여부 체크,
    }
  },
  computed : { 
    // 부모창에 휴대폰번호 형태로 제공 
    phonenumber() { 
      return this.phone1 + '-' + this.phone2 + '-' + this.phone3
    },
    isAbonumberValid() {
      if (this.abonumber.trim() == '') {
        return false
      } else { 
        return true
      }
    },
    isAbonameValid() {
      if (this.aboname.trim() == '') {
        return false
      } else { 
        return true
      }
    },
    // 신청하기 버튼에 대한 Style 효과 처리 
    joinButtonColor() {
      const colors = {
        no : {'background-color': '#808285'}, // 조건 미달시 회색버튼 처리 
        yes : {'background-color': 'rgb(0, 180, 50)'} // 조건 달성시 녹색버튼 처리
      }

      // 약관 동의 여부, 휴대폰 입력값 체크 
      if (this.agree && this.isPhoneValid && this.isAbonameValid && this.isAbonumberValid) {
        return colors.yes
      } else { 
        return colors.no
      }

    }
  },
  methods: {
    letGoJoin () {
      if (!this.isAbonameValid){
        this.$emit('alert', 'validName') //ABO 이름을 입력 해주세요.
      } else if (!this.isPhoneValidEmpty) {
        this.$emit('alert', 'validPhoneEmpty') // 올바른 휴대폰 번호를 올바르게 입력해주세요.
      } else if (!this.isPhoneValid) {
        this.$emit('alert', 'validPhone') // 올바른 휴대폰 번호를 올바르게 입력해주세요.
      } else if (!this.isAbonumberValid){
        this.$emit('alert', 'validAboNumber') // ABO 번호를 입력 해주세요.
      } else if (!this.agree) { 
        this.$emit('alert', 'validTerms') // 개인 정보 동의 체크해 주세요.
      } else if (this.agree && this.isPhoneValid) { 
        this.$emit('join', this.abonumber, this.aboname, this.phonenumber)
      } 
    },
    phoneValid() {
      // 휴대폰번호 입력창에 제한조건 체크 ( 3 -3 - 4)
      if (/[0-9]{3}/g.test(this.phone1) & /(\d{3}|\d{4})+$/g.test(this.phone2) & /[0-9]{4}/g.test(this.phone3)) {
        this.isPhoneValid = true
      }else { 
        this.isPhoneValid = false
      }

      // 휴대폰번호 입력 제한 체크(미입력)
      if ( this.phone1.match(/^$/) | this.phone2.match(/^$/) | this.phone3.match(/^$/)) {
        this.isPhoneValidEmpty = false // 미입력 
      }else {
        this.isPhoneValidEmpty = true // 입력 
      }
    },
    // 기본값 초기화 
    init() {
      this.phone1 = ''
      this.phone2 = ''
      this.phone3 = ''
      this.isPhoneValid = false
      this.agree = false
    }
  },
  mounted() {
    // mount 시에 모든 항목값 초기화 
    this.init()
  },
};
</script>
<style scoped>
@import "../css/font_kr.css";

.os_noticeRes .osResHeader{background: url(https://www.amway.co.kr/_ui/_noticeImg/2023/03/0329_ev_a7070xgli/bg.jpg) no-repeat; padding-bottom: 62em; background-size: cover; background-position:center 90%;}
.os_noticeRes ul.list_syleOne li::before{content:''; height:16px; width:16px; border:1px solid #ddd; border-radius:50%; display:inline-block; vertical-align:middle; margin-right:.5em;}
.os_noticeRes .cont_info{align-items: center; display: flex;}
.os_noticeRes .cont_info label{margin-bottom:0;}
.os_noticeRes .cont_info input{border-radius:.5em;}
.os_noticeRes .cont_info input[type="text"]{padding:0 12px;}
.os_noticeRes .cont_info input::placeholder {font-size:14px; letter-spacing:-.8px;}

@media screen and (max-width:1250px) {
  .os_noticeRes .osResHeader{padding-bottom:56em;}
}
@media screen and (max-width:1024px) {
  .os_noticeRes .osResHeader{padding-bottom:49em;}
}
@media screen and (max-width:768px) {
  .os_noticeRes .osResHeader{padding-bottom:40em;}
}
  @media screen and (max-width:639px) {
  .os_noticeRes .osResHeader{padding-bottom:34em;}
}

</style>


// WEBPACK FOOTER //
// src/views/nutrilite/a7070-glister/component/join.vue